<template>
  <div>
    <div class="container-block" style="margin: 15px 0">
      <a-form-model layout="inline">
        <a-form-model-item label="配方名称">
          <a-input
            style="width: 200px"
            placeholder="输入名称/代码"
            @pressEnter="getList(search)"
            v-model="search.formulaKeyword"
          />
        </a-form-model-item>
        <a-form-model-item label="选择动物">
          <animal-select
            style="width: 200px"
            @change="anmimlChange"
            :val="animal"
          />
        </a-form-model-item>
        <!-- 新增线路搜索条件 -->
        <a-form-model-item label="线路">
          <a-select style="width: 200px" v-model="search.lineId" placeholder="选择线路" allow-clear>
            <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click.enter="() => getList(search)"
              >搜索</a-button
            >
            <a-button @click="resetList">清空</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="editBox">
      <template v-for="el in menuBtnList">
        <template v-if="el.code.indexOf('third') < 0">
          <a-button
            :key="el.id"
            :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''"
            :ghost="el.code === 'delete'"
            :disabled="(isDelete && el.code === 'delete') || (isEdit && el.code === 'edit')"
            @click="clickFunc(el.path,el.code)"
          >
            {{el.name}}
          </a-button>
        </template>
      </template>
    </div>

    <a-table
      :columns="columns"
      :loading="customizedLoading"
      :data-source="list.records"
      :row-selection="{ selectedRowKeys, onChange: onSelectChange, getCheckboxProps }"
      row-key="id"
      :pagination="pagination"
      @change="listChange"
      class="tableBox"
    >
      <a-tooltip slot="formulaName" slot-scope="text, record">
        <template slot="title">
          {{ text }}
        </template>
        <a @click="goEditor(record)">{{ text }}</a>
      </a-tooltip>
      <a slot="sortNum" slot-scope="t,record"  @click="showSortModal(record)">
        {{ t || t === 0 ? t : '排序' }}
      </a>
      <template slot="x" slot-scope="t,record">
        <a @click="goEditor(record)">配方设计</a>
        <a-divider type="vertical" />
        <a @click="showSortModal(record)">排序</a>
        <a-divider type="vertical" />
        <a @click="copyRow(record)">复制</a>
      </template>
    </a-table>
    <compound-create-modal :hidden="addVisible" :formulaId="formulaId" @close="closeAdd" />
    <copy-compound-modal :hidden="copyVisible" :rowData="rowData" @close="closeCopy" />
    <sort-modal :hidden="sortModalVisible" @close="hideSortModal" :rowData="sortData" />
  </div>
</template>


<script>
import { nhfMixins } from "../untils";
import AnimalSelect from "./select/AnimalSelect.vue";
import CompoundCreateModal from './modal/CompoundCreateModal.vue'
import CopyCompoundModal from './modal/CopyCompoundModal.vue'
import SortModal from './modal/SortModal.vue'
export default {
  props: ['btnList'],
  components: {AnimalSelect,CompoundCreateModal,CopyCompoundModal,SortModal},
  mixins: [nhfMixins],
  data(){
    return {
      sortModalVisible: false,
      sortData: {},
      animal: [],
      search: {},
      menuBtnList: [],
      columns: [
        {
          title: "配方名称",
          dataIndex: "formulaName",
          scopedSlots: { customRender: "formulaName" },
          width: 140,
          ellipsis: true,
        },
        {
          title: "代码",
          dataIndex: "formulaCode",
          width: 120,
          ellipsis: true,
        },
        {
          title: "动物类型",
          dataIndex: "animalTypeName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "客户",
          dataIndex: "customName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "工厂名称",
          dataIndex: "factoryName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "排序",
          dataIndex: "sortNum",
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: "sortNum" },
        },
        {
          title: "用户",
          dataIndex: "userName",
          width: 80,
          ellipsis: true,
        },
        {
          title: "编辑时间",
          dataIndex: "updateTime",
          width: 180,
          ellipsis: true,
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 100,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "x",
          width: 240,
          align: "center",
          scopedSlots: { customRender: "x" },
        },
      ],
      customizedLoading: false,
      formulaId: '',
      addVisible: false,
      copyVisible: false,
      rowData: {},
      factoryId: window.localStorage.getItem('factoryId'),
      // 新增线路数据
      lineList: [],
    }
  },
  computed:{
    rowSelection(){
      return {
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys
      }
    },
    isDelete(){
      return this.selectedRowKeys.length === 0
    },
    isEdit(){
      return this.selectedRowKeys.length !== 1
    }
  },
  watch: {
    btnList: {
      handler(val){
        this.dealBtnList(val)
      },
      deep: true
    }
  },
  created(){
    this.dealBtnList(this.btnList)
    this.getList()
    this.getLineList()
  },
  methods: {
    hideSortModal(type){
      if(type) this.getList(this.search)
      this.sortModalVisible = false
    },
    showSortModal(record){
      this.sortData = record
      this.sortModalVisible = true
    },
    goEditor({ id }) {
      // let { current, pageSize } = this.pagination;
      // window.localStorage.setItem("compoundCurrent", current);
      // window.localStorage.setItem("compoundSize", pageSize);
      this.$router.push(`/nhf/customized-formula?id=${id}`);
    },
    listChange(page) {
      let {pageSize} = page || {}
      window.localStorage.setItem('customizedSize',pageSize)
      this.getList({ ...this.tablePageChange(page), ...this.filterData ,...this.search});
    },
    dealBtnList(val=[]){
      let menuObj = val.find(e => e.code === "customized") || {}
      if(menuObj && menuObj.children && menuObj.children.length){
        this.menuBtnList = menuObj.children || []
      }else{
        this.menuBtnList = []
      }
    },
    getList(arg = {}) {
      // let current = window.localStorage.getItem("compoundCurrent");
      // let size = window.localStorage.getItem("compoundSize");
      let {current=1,size=20} = arg || {}
      const data = {
        factoryId: this.factoryId,
        formulaType: 4,
        query: {current,size},
        ...arg,
      };
      // if (current) data.query.current = Number(current);
      // if (size) data.query.size = Number(size);
      this.fetchPost({
        actions: this.getCustomFormulaPage,
        isList: true,
        data,
        name: "list",
        loading: "customizedLoading",
        showMessage: false
      });
    },
    resetList(){
      this.search = {status: 0};
      this.animal = [];
      this.getList(this.search);
    },
    anmimlChange(val){
      this.animal = val;
      this.search.animalTypeCode = [...val].pop();
    },

    clickFunc(functionName,type){
      this[functionName](type)
    },
    addRow(){
      this.modalType = 'add'
      this.formulaId = ''
      this.addVisible = true
    },
    async deleteRow(){
      this.$confirm({
        title: "提示",
        content: "确认将选中的配方删除吗？",
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          let ids = this.selectedRowKeys.join(',')
          let res = await this.fetchPost({
            actions: this.removeCustomFormulaByIds,
            data: {ids},
            hasRes: true
          });
          let {code} = res || {}
          if (code === 200) {
            this.cleanSelect();
            this.getList(this.search);
          }
        }
      })
    },
    copyRow(record){
      this.rowData = {...record}
      this.copyVisible = true
    },
    closeAdd(type){
      if(type) this.getList()
      this.addVisible = false
    },
    closeCopy(type){
      if(type) this.getList()
      this.copyVisible = false
    },
  // 新增获取线路列表的方法
  async getLineList() {
    try {
      const res = await this.$http.get('/nhf-core-data/line/list', { params: { current: 1, size: 10000 } });
      if (res.success) {
        this.lineList = res.data.records || [];
      }
    } catch (error) {
      console.error('获取线路列表失败:', error);
    }
  },
  }
}
</script>
